"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TourLocationBlock = function TourLocationBlock(_ref) {
  var status = _ref.status,
      pois = _ref.pois,
      number = _ref.number,
      postalCode = _ref.postalCode,
      city = _ref.city,
      countryCode = _ref.countryCode,
      street = _ref.street;

  if (pois.length > 0) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold mb-1 flex items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Location, {
      className: "h-3 w-3 mr-1 fill-primary"
    }), /*#__PURE__*/_react["default"].createElement("span", null, pois.map(function (poi, index) {
      if (index === 0) {
        return poi.name;
      }

      return ", ".concat(poi.name);
    })));
  }

  var composedAddress = null;

  if (number || postalCode || city || countryCode || street) {
    composedAddress = street ? "".concat(street, " ") : '';
    composedAddress += number ? "".concat(number, " ") : '';

    if (composedAddress !== '') {
      composedAddress += '| ';
    }

    if (countryCode) {
      composedAddress += "".concat(countryCode, "-");
    }

    if (postalCode) {
      composedAddress += "".concat(postalCode, " ");
    }

    if (city) {
      composedAddress += city;
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "font-bold mb-1 flex items-center"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Location, {
      className: "h-3 w-3 mr-1 fill-primary"
    }), /*#__PURE__*/_react["default"].createElement("span", null, composedAddress));
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Location, {
    className: "fill-primary mr-1"
  }), status === _constants.TOUR_STATUS.RUNNING && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.infoBlock.positionUnknown"
  }));
};

TourLocationBlock.propTypes = {
  status: _propTypes["default"].string,
  pois: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string
  })),
  number: _propTypes["default"].number,
  postalCode: _propTypes["default"].string,
  city: _propTypes["default"].string,
  countryCode: _propTypes["default"].string,
  street: _propTypes["default"].string
};
TourLocationBlock.defaultProps = {
  status: null,
  pois: [],
  number: null,
  postalCode: null,
  city: null,
  countryCode: null,
  street: null
};
var _default = TourLocationBlock;
exports["default"] = _default;